'use client'

import type { ReactNode } from 'react'
import { PanelsSurfaceProvider, type PanelsSkin, type PanelsSurface } from '@/deskUiSkeletons/Page/PanelsSurfaceContext'
import { MoreLink } from '@/deskUiSkeletons/Shared/Shared'
import { mainTemplateVariant, menuTemplateVariant } from '../rowTemplates/RowTemplateConfig'
import { ForumCheckedsInfo, ForumFoldSubsButton, ForumPagingBar, ForumRefreshSubs } from './ForumControls'

const forumPanelsSkin: PanelsSkin = {
  toolbar: 'mb-2 flex min-h-6 items-center font-[Verdana,Arial,Helvetica,sans-serif]',
  toolbarHide: 'cursor-pointer border border-[#006699] bg-[#eef3f8] px-2 py-1 text-[10px] font-bold text-[#006699] hover:bg-[#dfe6ef]',
  toolbarMessage: 'hidden',
  panelAnswers: 'md-forum-panel relative mb-4 flex flex-col border border-[#006699] bg-white p-2',
  panelSubmsges: 'md-forum-panel relative mb-4 flex flex-col border border-[#006699] bg-white p-2',
  panelTools: 'mb-2 flex min-h-6 flex-wrap items-center gap-1 border-b border-[#006699] pb-2',
  rootList: 'flex list-none flex-col gap-2 p-0 text-[11px]',
  sectionInfo: 'mb-2 block bg-[#006699] px-2 py-1 text-[11px] font-bold text-white',
  sectionInfoCount: 'ml-1',
  menuPanel: 'relative flex-col border border-[#006699] bg-white p-2',
  menuPanelShown: '!flex',
  menuPanelHidden: '!hidden',
  togglePhoto: 'hidden',
  menuPanelTools: 'mb-2 flex min-h-6 flex-wrap items-center gap-1 border-b border-[#006699] pb-2',
  menuList: 'flex list-none flex-col gap-2 p-0 text-[11px]',
  sectionSwitch: 'mb-2 flex w-max border border-[#006699] bg-[#eef3f8] text-[10px]',
  sectionSwitchButton: 'border-r border-[#006699] px-3 py-1 last:border-r-0',
  sectionSwitchButtonActive: 'bg-[#006699] font-bold text-white',
  sectionSwitchButtonInactive: 'bg-[#eef3f8] font-bold text-[#006699] hover:bg-[#dfe6ef]',
  menuEmpty: 'px-3 py-3 text-[11px] text-[#5a6b7a]',
}

const forumPanelsSurface: PanelsSurface = {
  FoldSubsButton: ForumFoldSubsButton,
  PagingBar: ForumPagingBar,
  RefreshSubs: ForumRefreshSubs,
  CheckedsInfo: ForumCheckedsInfo,
  MoreLink,
  menuEmptyLabel: 'No posts',
  config: { mainTemplateVariant, menuTemplateVariant },
  skin: forumPanelsSkin,
}

export function ForumPanelsSurfaceProvider({ children }: { children: ReactNode }) {
  return <PanelsSurfaceProvider value={forumPanelsSurface}>{children}</PanelsSurfaceProvider>
}
